import React from "react";
import "../assets/css/industriesSection.css";

function IndustriesSection() {
    const items = [
        "Abrasive Industry",
        "Wood Working Industry",
        "Rubber Industry",
        "Refactories",
        "Cork Industry",
        "Bakelite Industry",
        "Coating Industry",
        "Foundry Industry",
    ];

    return (
        <>
            <div className="industries-wrapper">
                <section className="industries-section">
                    <div className="industries-header">
                        <span className="industries-label">INDUSTRIES WE SERVE</span>
                        <h2>
                            Delivering high-performance resins trusted across multiple industrial
                            applications.
                        </h2>
                    </div>

                    {/* Marquee */}
                    <div className="industries-marquee">
                        <div className="marquee-track">
                            {[...items, ...items].map((title, index) => (
                                <div className="marquee-item" key={index}>
                                    {title}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default IndustriesSection;
